
export type UUID = string;
const DELIMITER = ':';

export class ResourceUUIDVersionIdentifier {
    constructor(public readonly id: UUID, public readonly version: number) { }

    toString(): string {
        return `${this.id}${DELIMITER}${this.version}`;
    }

    increaseVersion(): ResourceUUIDVersionIdentifier {
        return new ResourceUUIDVersionIdentifier(this.id, this.version + 1);
    }

    static createFromString(value: string): ResourceUUIDVersionIdentifier {
        if (value == null)
            throw new Error('empty');
        const splited = value.split(DELIMITER);
        if (splited.length !== 2)
            throw new Error('not full version');
        return new ResourceUUIDVersionIdentifier(splited[0], parseIntOrThrow(splited[1]));
    }

    equals(other: ResourceUUIDVersionIdentifier): boolean {
        if (other == null)
            return false;
        return this.id === other.id && this.version === other.version;
    }

}


export class ResourceNumericVersionIdentifier {
    constructor(public readonly id: number, public readonly version: number) { }

    toString(): string {
        return `${this.id}${DELIMITER}${this.version}`;
    }

    increaseVersion(): ResourceNumericVersionIdentifier {
        return new ResourceNumericVersionIdentifier(this.id, this.version + 1);
    }

    static createFromString(value: string): ResourceNumericVersionIdentifier {
        if (value == null)
            throw new Error('empty');
        const splited = value.split(DELIMITER);
        if (splited.length !== 2)
            throw new Error('not full version');
        return new ResourceNumericVersionIdentifier(parseIntOrThrow(splited[0]), parseIntOrThrow(splited[1]));
    }

    equals(other: ResourceNumericVersionIdentifier): boolean {
        if (other == null)
            return false;
        return this.id === other.id && this.version === other.version;
    }

}

function parseIntOrThrow(value: string): number {
    const parsed = parseInt(value, 10);

    if (Number.isNaN(parsed)) {
        throw new Error(`Invalid integer while parsing versioned resource, value: "${value}"`);
    }

    return parsed;
}
